import i18n from "i18n/i18n";
import moment, { Moment } from "moment";
import React from "react";

import { DatePicker, Grid, Icons, Modal } from "@texada/ui";

interface IContractArchiveModal {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void | Promise<void>;
  onSubmit: (date: Moment) => void | Promise<void>;
}

const getDefaultDate = () => moment().subtract(1, "y");

export const ContractArchiveModal: React.FC<IContractArchiveModal> = ({
  isOpen,
  onCancel,
  isLoading,
  onSubmit
}) => {
  const [date, setDate] = React.useState<Moment>(getDefaultDate());

  const handleCancel = () => {
    if (onCancel) onCancel();
    setDate(getDefaultDate());
  };

  const handleSubmit = async () => {
    if (onSubmit) {
      const result = onSubmit(date);
      if (result instanceof Promise) {
        await result;
      }
      setDate(getDefaultDate());
    }
  };

  const handleChange = date => {
    setDate(date);
  };

  return (
    <Modal
      size={"xs"}
      isOpen={isOpen}
      header={i18n.t("archive_contracts")}
      onCancel={handleCancel}
      isLoading={isLoading}
    >
      <Modal.Body padded={false}>
        <Grid.Row>
          <Grid.Col>
            <DatePicker
              label={i18n.t("archive_contracts_older_than")}
              date={date}
              onChange={handleChange}
              maxDate={new Date()}
            />
            <div
              className="invalid-feedback"
              children={i18n.t(
                "we_recommend_utilizing_the_archive_feature_outside_of_regular_business_hours"
              )}
            />
          </Grid.Col>
        </Grid.Row>
      </Modal.Body>
      <Modal.Footer
        saveButton
        saveButtonText={i18n.t("archive")}
        closeButton
        onSubmit={handleSubmit}
        saveButtonProps={{
          icon: { type: "left", render: () => <Icons.Archive /> }
        }}
      />
    </Modal>
  );
};
